export const getLocalStorageValue = <T>(key: string): T | null => {
    const value = localStorage.getItem(key);
    return value ? (JSON.parse(value) as T) : null;
}

export const setLocalStorageValue = <T>(key: string, value: T) => {
    localStorage.setItem(key, JSON.stringify(value));
}
